export enum MessageType {
    SetQuestionValue = 'set-question-value',
    ChangeTheme = 'change-theme',
    SetStylesTemplate = 'setStylesTemplate',
    ClearStyles = 'clearStyles',
}
